/**
 * @description Processes getDropdownOptions API responses into a list of dropdown options sorted using the order field
 */

/**
 * Processes getDropdownOptions API responses into a list of dropdown options sorted using the order field
 * @param {{name: string, value: string, id: number, order: number}[]} response - raw api response
 * @returns {{ label: string, value: string }[]} - dropdown options
 */
const processOrderedDropdownOptions = (response) => {
  let newList = [];

  // Without this, errors fail silently in react-query's select callback
  try {
    newList = response
      ?.toSorted((a, b) => a.order - b.order)
      ?.map((entry) => ({ label: entry.name, value: entry.value }));
  } catch (err) {
    console.error(err);
  }

  return newList;
};

export default processOrderedDropdownOptions;
